import { Stack, Table, Text } from '@mantine/core'
import { useMediaQuery } from '@mantine/hooks'
import { AutoRenewingAdResponse } from '../../../data/hostDashboard.service'
import { COLORS } from '../../../utils/constants'
import { formatNumber } from '../../../utils/displayUtils'
import AutoRenewingAdCard from './AutoRenewingAdCard'

type AutoRenewingAdsTableProps = {
  ads: AutoRenewingAdResponse[]
}

const getRefreshIntervalLabel = (numberOfDays: number): string => {
  switch (numberOfDays) {
    case 7:
      return '1 week'
    case 14:
      return '2 weeks'
    case 30:
      return '1 month'
    case 90:
      return '3 months'
    default:
      return `${numberOfDays} days`
  }
}

const AutoRenewingAdsTable = ({ ads }: AutoRenewingAdsTableProps) => {
  const isMobile = useMediaQuery('(max-width: 768px)')

  if (isMobile) {
    return (
      <Stack gap='md'>
        {ads.map((ad) => (
          <AutoRenewingAdCard key={ad.id} ad={ad} />
        ))}
      </Stack>
    )
  }

  return (
    <Table striped highlightOnHover withTableBorder>
      <Table.Thead>
        <Table.Tr>
          <Table.Th>Advertiser</Table.Th>
          <Table.Th>Location / Device</Table.Th>
          <Table.Th>Ad Name</Table.Th>
          <Table.Th>Refresh Interval</Table.Th>
          <Table.Th>Next Renewal Date</Table.Th>
          <Table.Th>Amount</Table.Th>
        </Table.Tr>
      </Table.Thead>
      <Table.Tbody>
        {ads.map((ad) => {
          return (
            <Table.Tr key={ad.id}>
              <Table.Td>{ad.advertiserOrganizationName}</Table.Td>
              <Table.Td>{`${ad.locationName} - ${ad.deviceName}`}</Table.Td>
              <Table.Td>{ad.adName}</Table.Td>
              <Table.Td>
                {ad.numberOfDaysToRunAd
                  ? getRefreshIntervalLabel(ad.numberOfDaysToRunAd)
                  : 'Custom'}
              </Table.Td>
              <Table.Td>
                {new Date(ad.nextRenewalDate)?.toLocaleDateString()}
              </Table.Td>
              <Table.Td>
                <Text fw={600} c={COLORS.LightGreen}>
                  ${formatNumber(ad.lastTransferAmount)}
                </Text>
              </Table.Td>
            </Table.Tr>
          )
        })}
      </Table.Tbody>
    </Table>
  )
}

export default AutoRenewingAdsTable
